import ListItem from '@material-ui/core/ListItem'
import React from 'react'
import styles from '../../styles'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import { ClassValue } from 'classnames/types'
import { FormattedMessage, useIntl } from 'react-intl'
import List from '@material-ui/core/List'
import ExpandMore from '@material-ui/icons/ExpandMore'
import Collapse from '@material-ui/core/Collapse'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import { UserModel } from '../../types/user/userModel'
import logout from '../../api/logout'
import { RootState } from '../reducers'
import links from '../../enums/linksEnum'
import { useMediaQuery } from 'react-responsive'
import { useCookies } from 'react-cookie'
import { saveInteractions } from '../gtm/utils/gtmCallback'
import { redirectionVersAcquisitionResidence } from '../changementAppartement/utils/changementAppartementUtils'
import portals from '../../enums/portalsEnum'

const useStyles = makeStyles(theme => ({
	...styles(theme),
	nameStyle: {
		'& #accountCircle': {
			fontSize: '25px'
		},
		'& span': {
			margin: '0 10px'
		},
		'& #expandMore': {
			color: theme.palette.blue['30']
		}
	},
	subList: {
		height: '100%',
		textTransform: 'inherit',
		padding: '15px 15px',
		width: '100%',

		'& #chevronRight': {
			color: theme.palette.blue['30']
		},
		'& img': {
			width: '20px',
			marginRight: '10px'
		}
	},
	// Les items porteurs d'un chevron alignent le libellé à gauche et le chevron à droite.
	// (classe explicite plutôt que :first-child, car les items du menu sont conditionnels)
	subListChevron: {
		justifyContent: 'space-between'
	},
	collapseStyle: {
		minWidth: 140,
		position: 'absolute',
		width: '100%',
		background: 'white',
		borderRadius: '0 0 15px 15px',
		boxShadow: '0 25px 50px 0 rgba(18, 41, 65, 0.1)'
	}
}))

interface AcceptingProps {
	onClick: (link: string) => void,
	locale: string
}

type ProfileMenuProps = AcceptingProps

const ProfileMenu: React.FC<ProfileMenuProps> = (
	{
		onClick
	}
) => {
	const classes = useStyles()
	const user: UserModel = useSelector((state: RootState) => state.user)
	const dossier = useSelector((state: RootState) => state.dossier)
	const intl = useIntl()
	const [open, setOpen] = React.useState<boolean>(false)
	const removeCookies = useCookies()[2]

	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1300px)'
		}
	)

	const handleClick = () => {
		setOpen(!open)
	}

	const nameClass: ClassValue = classNames(
		classes.colorBlue,
		classes.text4,
		classes.nameStyle
	)
	const subListClass: ClassValue = classNames(
		classes.subList,
		classes.text4,
		classes.colorBlue
	)
	const subListChevronClass: ClassValue = classNames(
		subListClass,
		classes.subListChevron
	)

	return (
		<>
			<List className={classes.cursorPointer}>
				<ListItem
					onClick={handleClick}
					className={nameClass}
				>
					<img
						src="img/profile.svg"
						alt="Profile icon"
						id="accountCircle"
					/>
					{isLargeScreen && <span>{user.firstname} {user.lastname}</span>}
					<ExpandMore id="expandMore" />
				</ListItem>

				<Collapse
					in={open}
					timeout="auto"
					unmountOnExit
					addEndListener={() => {
					}}
					className={classes.collapseStyle}
				>
					<List
						component="div"
						disablePadding
					>
						<ListItem
							className={subListChevronClass}
							onClick={() => {
								saveInteractions(
									{
										category: 'Profil',
										action: 'Votre profil',
										label: 'Accès à votre profil'
									}
								)
								onClick(links.profile)
								handleClick()
							}}
						>
							<FormattedMessage
								id="menu.profile"
								defaultMessage="Votre profil"
								description="Profile text"
							/>

							<ChevronRightIcon id="chevronRight" />
						</ListItem>

						{process.env.REACT_APP_TARGET === portals.residence && dossier && (
							<ListItem
								className={subListChevronClass}
								onClick={() => redirectionVersAcquisitionResidence(intl.locale)}
							>
								<FormattedMessage
									id="menu.dossier"
									defaultMessage="Votre dossier"
									description="Lien vers le suivi de dossier sur l'acquisition résidence"
								/>

								<ChevronRightIcon id="chevronRight" />
							</ListItem>
						)}

						<ListItem
							className={subListClass}
							onClick={() => logout(removeCookies)}
						>
							<img src="img/logout.png" alt="Logout icon" />

							<FormattedMessage
								id="menu.logout"
								defaultMessage="Se déconnecter"
								description="Logout text"
							/>
						</ListItem>
					</List>
				</Collapse>
			</List>
		</>
	)

}

export default ProfileMenu
